import { Injectable, inject } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { tap } from "rxjs/operators";
import {
  ActionAuthLogin,
  ActionAuthLogout,
  AUTH_KEY,
  AuthActionTypes,
  LocalStorageService
} from "@app/core";

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private localStorageService = inject(LocalStorageService);

  login$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGIN),
        tap((action: ActionAuthLogin) => {
          this.localStorageService.setItem(AUTH_KEY, {
            isAuthenticated: true,
            isAdmin: (<any>action).payload.isAdmin,
            isPlanner: (<any>action).payload.isPlanner,
            isViewer: (<any>action).payload.isViewer,
            fullName: (<any>action).payload.fullName
          });
          // console.log(action);
        })
      ),
    { dispatch: false }
  );

  logout$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(AuthActionTypes.LOGOUT),
        tap((action: ActionAuthLogout) => {
          this.localStorageService.setItem(AUTH_KEY, {
            isAuthenticated: false,
            isAdmin: false,
            isPlanner: false,
            isViewer: false,
            fullName: "Unknown User"
          });
          console.log(action);
        })
      ),
    { dispatch: false }
  );
}
